<template>
    <div class="popularize">
        <img class="top-banner" :src="`${GET_STATIC_IMG_HOST}popularize/others/banner2.jpg`">
        <div class="content-wrapper">
            <div class="top-context">
                <p>也许你还不知道，《摸金天师》《超品相师》《卑鄙的圣人：曹操》……</p>
                <p>这些被亿万听众熟知的经典有声作品，都来自作品有声化平台</p>
                <p>加入我们，拥有你的专属团队，迎接你的万千粉丝</p>
            </div>
            <div class="separate-line"></div>
            <div class="best-work-list">
                <div class="work-wrapper">
                    <a href="http://www.ximalaya.com/1266964/album/4756811/"><img :src="`${GET_STATIC_IMG_HOST}popularize/day2/摸金天师.jpg`" class="cover"></a>
                    <div class="work-content">
                        <div class="work-top">
                            <a href="http://www.ximalaya.com/1266964/album/4756811/" class="work-name">《摸金天师》</a>
                            <span class="listen-count"><strong>123000万</strong>次播放</span>
                        </div>
                        <a href="http://www.ximalaya.com/zhubo/1266964/" class="anchor-name">主播：有声的紫襟</a>
                        <span class="desc">秦岭大山里的墓葬群，西北戈壁中的无人区，浩瀚深海下的失落遗迹，雪域高原上的死亡禁区……<br>或许有一天，当你因为贪婪而拿了不该拿的东西时，你就会发现睡觉时有东西站你旁边，告诉你，天黑了，一起来玩玩吧。</span>
                    </div>
                </div>
                <div class="separate-line"></div>
                <div class="work-wrapper">
                    <a href="http://www.ximalaya.com/4932085/album/3160816/"><img :src="`${GET_STATIC_IMG_HOST}popularize/day2/超品相师.jpg`" class="cover"></a>
                    <div class="work-content">
                        <div class="work-top">
                            <a href="http://www.ximalaya.com/4932085/album/3160816/" class="work-name">《超品相师》</a>
                            <span class="listen-count"><strong>82000万</strong>次播放</span>
                        </div>
                        <a href="http://www.ximalaya.com/zhubo/4932085/" class="anchor-name">主播：丸子</a>
                        <span class="desc">相师分九品，一品一重天，二品是入门，三品算是登堂，四品之后才能真正的称为相师。风水有境界、明理、养气、修身、问道。<br>二十一世纪的一位普通青年秦宇偶获诸葛亮生前的玄学传承，从此混迹都市，游走于高官权贵之间，豪门千金，世家小姐身侧……</span>
                    </div>
                </div>
                <div class="separate-line"></div>
                <div class="work-wrapper">
                    <a href="http://www.ximalaya.com/2979487/album/2684111/"><img :src="`${GET_STATIC_IMG_HOST}popularize/day2/卑鄙的圣人：曹操.jpg`" class="cover"></a>
                    <div class="work-content">
                        <div class="work-top">
                            <a href="http://www.ximalaya.com/2979487/album/2684111/" class="work-name">《卑鄙的圣人：曹操》</a>
                            <span class="listen-count"><strong>7500万</strong>次播放</span>
                        </div>
                        <a href="http://www.ximalaya.com/zhubo/2979487/" class="anchor-name">主播：文涛学员</a>
                        <span class="desc">一件件讲透，曹操收拾三国群雄的卑鄙、奸诈、狠毒计谋；一页页浸透，曹操体恤天下众生的柔情、仁义、圣人情怀。<br>曹操的计谋，奸诈程度往往将对手整得头昏脑涨、找不着北，卑鄙程度也屡屡突破道德底线，但他却是一个心怀天下、体恤众生的圣人……</span>
                    </div>
                </div>
            </div>
            <div class="separate-line"></div>
            <div class="top-work-wrapper">
                <span class="title">- 这些作品都产生于这里 -</span>
                <div class="top-work-list">
                    <div class="work-wrapper">
                        <a href="http://www.ximalaya.com/16945541/album/4615999/"><img class="cover" :src="`${GET_STATIC_IMG_HOST}popularize/day2/斗破苍穹.jpg`"></a>
                        <div class="work-right">
                            <a href="http://www.ximalaya.com/16945541/album/4615999/" class="work-name">斗破苍穹</a>
                            <span class="desc">超级IP改编有声剧，玄幻网文至尊经典小说！<br>网络总点击20亿次！各大网络文学榜单NO.1大满贯之作！</span>
                        </div>
                    </div>
                    <div class="work-wrapper">
                        <a href="http://www.ximalaya.com/1199493/album/294834/"><img class="cover" :src="`${GET_STATIC_IMG_HOST}popularize/day2/从你的全世界路过.gif`"></a>
                        <div class="work-right">
                            <a href="http://www.ximalaya.com/1199493/album/294834/" class="work-name">从你的全世界路过</a>
                            <span class="desc">喜马拉雅出品，微博最会讲故事的人——张嘉佳，睡前故事集《从你的全世界路过》唯一指定官方有声系列</span>
                        </div>
                    </div>
                    <div class="work-wrapper">
                        <a href="http://www.ximalaya.com/1884830/album/350700/"><img class="cover" :src="`${GET_STATIC_IMG_HOST}popularize/day2/刘心武揭秘红楼梦.jpg`"></a>
                        <div class="work-right">
                            <a href="http://www.ximalaya.com/1884830/album/350700/" class="work-name">刘心武揭秘红楼梦</a>
                            <span class="desc">著名作家刘心武在央视所作的红学系列讲座同名书籍，解读了出书中数十位人物命运轨迹，由此提出诸多新的高级精神内涵。</span>
                        </div>
                    </div>
                    <div class="work-wrapper">
                        <a href="http://www.ximalaya.com/1266964/album/9877679/"><img class="cover" :src="`${GET_STATIC_IMG_HOST}popularize/day2/狠人狠事.jpg`"></a>
                        <div class="work-right">
                            <a href="http://www.ximalaya.com/1266964/album/9877679/" class="work-name">狠人狠事</a>
                            <span class="desc">有声的紫襟。喜马拉雅FM超人气王牌主播倾情演绎，声音磁性，演播方式多变，讲述了真正的黑道，真正的江湖！</span>
                        </div>
                    </div>
                    <div class="work-wrapper">
                        <a href="http://www.ximalaya.com/1266964/album/356310/"><img class="cover" :src="`${GET_STATIC_IMG_HOST}popularize/day2/藏地密码.jpg`"></a>
                        <div class="work-right">
                            <a href="http://www.ximalaya.com/1266964/album/356310/" class="work-name">藏地密码</a>
                            <span class="desc">以120万字的宏大架构，讲述了以西藏为背景的一个全球大探险故事，其中涉及到西藏千年秘史、藏传佛教历史遗案，以及世界上众多著名文化遗迹。</span>
                        </div>
                    </div>
                    <div class="work-wrapper">
                        <a href="http://www.ximalaya.com/13511549/album/8791642/"><img class="cover" :src="`${GET_STATIC_IMG_HOST}popularize/day2/活着.jpg`"></a>
                        <div class="work-right">
                            <a href="http://www.ximalaya.com/13511549/album/8791642/" class="work-name">活着</a>
                            <span class="desc">张艺谋电影《活着》原著小说，孟京辉话剧《活着》原著小说，电视剧《福贵》原著小说<br>即便生活中有苟且、痛苦与迷茫，也请欣然坚定地活着</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separate-line"></div>
            <div class="more-wrapper">
                <span class="title">- 了解更多 -</span>
                <div class="links-wrapper">
                    <router-link class="link" :to="{name: 'idols'}"><img :src="`${GET_STATIC_IMG_HOST}popularize/others/大神云集@2x.png`"></router-link>
                    <router-link class="link" :to="{name: 'workLib'}"><img :src="`${GET_STATIC_IMG_HOST}popularize/others/海量作品@2x.png`"></router-link>
                    <router-link class="link" :to="{name: 'benefits'}"><img :src="`${GET_STATIC_IMG_HOST}popularize/others/福利体系@2x.png`"></router-link>
                </div>
            </div>
            <router-link :to="{name: 'anchorIndex'}" class="btn-join-bottom">立即加入</router-link>
            <router-link :to="{name: 'anchorIndex'}" class="btn-join-fixed">立即加入</router-link>
        </div>
    </div>
</template>
<script>
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    methods: {
      setXMLog () {
        xmLog('pv.create', {
          item: "有声化平台首页"
        }),
          xmLog("pv.send", "event", {
            serviceId: "aBookView",
            item: "有声化推广页_经典汇聚"
          })
      }
    },
    computed: {
      GET_STATIC_IMG_HOST() {
        return this.$store.state.IMG_HOST;
      }
    },
    mounted () {

      // 埋点
      this.setXMLog ();
    }
  }
</script>
<style lang="sass" scoped>
    @import "../../sass/popularize/popularize-first.scss";
</style>



// WEBPACK FOOTER //
// Classic.vue?1d4c70a9